export { default } from "./Locator";



// WEBPACK FOOTER //
// ./src/locator/index.js